<template>
    <div class="w-full flex justify-center items-center">
        <h1 class="text-fculColor text-8xl lg:text-9xl font-bold">FUNDUS</h1>
    </div>
</template>

<script setup >
</script>
